import Edition2026 from './Edition2026'

export default class Edition2027 extends Edition2026 {
  getUrl() {
    return `${process.env.REACT_APP_GUILLOTINA}2027/`
  }

  getFiraDaysFilters(t) {
    return [
      [t('Dijous'), '14', '1823472000'],
      [t('Divendres'), '15', '1823558400'],
      [t('Dissabte'), '16', '1823644800'],
      [t('Diumenge'), '17', '1823731200'],
    ]
  }

  getFiraProfessionalActivitiesDaysFilters(t) {
    return [
      [t('Dijous'), '14', '1823472000'],
      [t('Divendres'), '15', '1823558400'],
      [t('Dissabte'), '16', '1823644800'],
      [t('Diumenge'), '17', '1823731200'],
    ]
  }
}
